export const getConferences = state => state.Conferences;

export default state => ({
    conferences: getConferences(state)
})


// WEBPACK FOOTER //
// ./src/modules/Conferences/selectors.js